import CustomButton from "../../../components/Button";
import DownArrowIcon from "../../../assets/Filter/downArrow.svg";
import UpArrowIcon from "../../../assets/Filter/upArrow.svg";
import RupeeIcon from "../../../assets/common/Rupee.svg";
import { useState } from "react";
import Collapsible from "react-collapsible";
// import { Cancelled } from "../StatusComponents";
// import copyIcon from "../../../assets/Transaction/CopyIcon.svg";
// import shareIcon from "../../../assets/Transaction/ShareIcon.svg";
import { createColumnHelper } from "@tanstack/react-table";
import filterIconTable from "../../../assets/Transaction/filtericon.svg";
// import sortIconTable from "../../../assets/Transaction/sortIcon.svg";
import CopyTooltip from "../../../components/CopyToClipboard";
import { date_DD_MMM_YYYY_HH_MM } from "../../../utils/dateFormater";
import bookedIcon from "../../../assets/Transaction/bookedIcon.svg";
import PendingIcon from "../../../assets/pendingRed.svg";
import { capitalizeFirstLetter, commaSeparator } from "../../../utils/utility";
import type {
  CycleWalletSortFn,
  WalletApiSortState,
} from "./passbookHistory";

interface ICashbackProps {
  data: {
    title: string;
    rupee: string;
    date: string;
    time: string;
    description: string;
    type: string;
    yaariCashBalance: number;
    transactionId: string;
    status: string;
    remark: string;
  };
}

const columnsHelper = createColumnHelper<any>();

const getCashbackTxType = (type: any) => String(type || "").toLowerCase();

const getCashbackAmount = (amount: any) => {
  const parsedAmount = Number(amount);
  return Number.isFinite(parsedAmount) ? parsedAmount : 0;
};

const isCashbackCredit = (type: any) => getCashbackTxType(type) === "credit";

const isCashbackDebit = (type: any) => getCashbackTxType(type) === "debit";

function SortChevron({
  active,
  dir,
}: {
  active: boolean;
  dir: 1 | -1;
}) {
  if (!active) {
    return (
      <span
        className="inline-block min-w-[12px] text-center text-xs font-semibold text-[#A4A4A4]"
        aria-hidden
      >
        ↕
      </span>
    );
  }

  return (
    <span
      className="min-w-[12px] text-center text-xs font-semibold text-[#1C1C1C]"
      aria-hidden
    >
      {dir === 1 ? "↑" : "↓"}
    </span>
  );
}

export const cashbackDetailsColumns = (opts: {
  apiSort: WalletApiSortState;
  cycleWalletSort: CycleWalletSortFn;
  onStatusFilterClick?: () => void;
  statusFilterActive?: boolean;
}) => {
  const {
    apiSort,
    cycleWalletSort,
    onStatusFilterClick,
    statusFilterActive,
  } = opts;

  const renderStatusComponent = (status: string) => {
    return (
      <div>
        <div
          className={`inline-flex items-center text-xs justify-center gap-x-2 ${
            status.toUpperCase() === "SUCCESS"
              ? "bg-[#F2FAEF] border-[#7CCA62]"
              : "bg-[#FEEEEB] border-[#F35838]"
          }  rounded-sm border-[0.5px] px-3 py-[6px]`}
        >
          <img
            src={`${
              status.toUpperCase() === "SUCCESS" ? bookedIcon : PendingIcon
            }`}
            alt=""
            width={20}
          />
          <span
            className={`text-xs font-semibold font-Open leading-5  ${
              status.toUpperCase() === "SUCCESS"
                ? "text-[#7CCA62]"
                : "text-[#F35838]"
            }  items-center`}
          >
            {status.toUpperCase()}
          </span>
        </div>
      </div>
    );
  };
  return [
    columnsHelper.accessor("createdAt", {
      header: (props: any) => {
        return (
          <div className="flex justify-between items-center">
            <div className="flex justify-center items-center">
              {/* <PartialChecked
                checked={props.table?.getIsAllRowsSelected()}
                onChange={props?.table?.getToggleAllRowsSelectedHandler()}
                intermediate={props?.table?.getIsSomeRowsSelected()}
              /> */}
              <h1 className="font-Open font-semibold leading-5 text-sm">
                Date
              </h1>
            </div>
            <button
              type="button"
              className="flex items-center justify-center rounded p-0.5 hover:bg-[#F0F0F0]"
              onClick={() => cycleWalletSort("_id")}
              title="Toggle date order: newest ↔ oldest (_id)"
              aria-label="Sort by date"
            >
              <SortChevron
                active={apiSort.key === "_id"}
                dir={apiSort.dir}
              />
            </button>
          </div>
        );
      },

      cell: (info: any) => {
        // console.log("timestamp", info.getValue());
        const formattedDateTime = date_DD_MMM_YYYY_HH_MM(info.getValue());

        return (
          <div className="flex items-center">
            {/* <div className="flex items-center justify-center mr-3 cursor-pointer">
              <input
                type="checkbox"
                checked={info?.row?.getIsSelected()}
                onChange={info?.row?.getToggleSelectedHandler()}
              />
            </div> */}
            <div className="flex flex-col  whitespace-nowrap my-4 ">
              <span className="font-Open font-normal leading-5 text-sm">
                {formattedDateTime.split(",")[0]}
              </span>
              <span className="font-Open font-normal leading-5 text-sm">
                {formattedDateTime.split(",")[1]}
              </span>
            </div>
          </div>
        );
      },
    }),
    columnsHelper.accessor("transactionId", {
      header: () => {
        return (
          <div className="flex whitespace-nowrap justify-between items-center w-[90px] ">
            <h1 className="font-Open font-semibold leading-5 text-sm">
              Transaction ID
            </h1>
            {/* <img src={sortIconTable} alt="" /> */}
          </div>
        );
      },
      cell: (info: any) => {
        return (
          <div className="flex  items-center justify-between ">
            <div className=" w-[80px] whitespace-nowrap  overflow-hidden overflow-ellipsis font-Open font-normal leading-5 text-sm   ">
              {info.row.original.transactionId}
            </div>
            <div className="cursor-pointer">
              <CopyTooltip stringToBeCopied={info.row.original.transactionId} />
            </div>
          </div>
        );
      },
    }),
    columnsHelper.accessor("awb", {
      header: () => {
        return (
          <div className="flex whitespace-nowrap justify-between items-center">
            <h1 className="font-Open font-semibold leading-5 text-sm">
              Tracking No
            </h1>
            {/* <img src={sortIconTable} alt="" /> */}
          </div>
        );
      },
      cell: (info: any) => {
        return (
          <div className="flex  items-center justify-between ">
            <div className=" font-Open font-normal leading-5 text-sm   ">
              {info.row.original.awb}
            </div>
            <div className="cursor-pointer">
              <CopyTooltip stringToBeCopied={info.row.original.awb} />
            </div>
          </div>
        );
      },
    }),

    columnsHelper.accessor(
      (row) =>
        isCashbackCredit(row?.type) ? getCashbackAmount(row?.yaariCash) : 0,
      {
        id: "credited",
        header: () => {
          return (
            <button
              type="button"
              className="flex w-full min-w-[108px] items-center justify-between gap-1 rounded-md border border-transparent px-1 py-0.5 text-left hover:border-[#E8E8E8] hover:bg-[#FAFAFA]"
              onClick={() => cycleWalletSort("credited")}
              title="Sort credited cashback: ascending ↔ descending"
              aria-label="Sort credited cashback"
            >
              <h1 className="font-Open text-sm font-semibold leading-5 text-[#2E7D32]">
                Credited
              </h1>
              <SortChevron
                active={apiSort.key === "credited"}
                dir={apiSort.key === "credited" ? apiSort.dir : 1}
              />
            </button>
          );
        },
        cell: (info: any) => {
          const isCredit = isCashbackCredit(info?.row?.original?.type);
          const credited = getCashbackAmount(info.getValue()).toFixed(2);

          return (
            <div className="flex whitespace-nowrap font-Open text-sm leading-5 tabular-nums">
              {isCredit ? (
                <span className="font-medium text-[#2E7D32]">
                  ₹ {commaSeparator(credited)}
                </span>
              ) : (
                <span className="text-[#9CA3AF]">₹ 0.00</span>
              )}
            </div>
          );
        },
      }
    ),

    columnsHelper.accessor(
      (row) =>
        isCashbackDebit(row?.type) ? getCashbackAmount(row?.yaariCash) : 0,
      {
        id: "debited",
        header: () => {
          return (
            <button
              type="button"
              className="flex w-full min-w-[100px] items-center justify-between gap-1 rounded-md border border-transparent px-1 py-0.5 text-left hover:border-[#E8E8E8] hover:bg-[#FAFAFA]"
              onClick={() => cycleWalletSort("debited")}
              title="Sort debited cashback: ascending ↔ descending"
              aria-label="Sort debited cashback"
            >
              <h1 className="font-Open text-sm font-semibold leading-5 text-[#C62828]">
                Debited
              </h1>
              <SortChevron
                active={apiSort.key === "debited"}
                dir={apiSort.key === "debited" ? apiSort.dir : 1}
              />
            </button>
          );
        },
        cell: (info: any) => {
          const isDebit = isCashbackDebit(info?.row?.original?.type);
          const debited = getCashbackAmount(info.getValue()).toFixed(2);

          return (
            <div className="flex whitespace-nowrap font-Open text-sm leading-5 tabular-nums">
              {isDebit ? (
                <span className="font-medium text-[#C62828]">
                  ₹ {commaSeparator(debited)}
                </span>
              ) : (
                <span className="text-[#9CA3AF]">₹ 0.00</span>
              )}
            </div>
          );
        },
      }
    ),

    columnsHelper.accessor("yaariCashBalance", {
      header: () => {
        return (
          <button
            type="button"
            className="flex w-full min-w-[132px] items-center justify-between gap-1 rounded-md border border-transparent px-1 py-0.5 text-left hover:border-[#E8E8E8] hover:bg-[#FAFAFA]"
            onClick={() => cycleWalletSort("balance")}
            title="Sort cashback balance: ascending ↔ descending"
            aria-label="Sort cashback balance"
          >
            <h1 className="font-Open text-sm font-semibold leading-5 text-[#1C1C1C]">
              Balance
            </h1>
            <SortChevron
              active={apiSort.key === "balance"}
              dir={apiSort.dir}
            />
          </button>
        );
      },
      cell: (info: any) => {
        let yaariCashBalance = parseFloat(info.getValue()).toFixed(2);

        return (
          <div className="flex whitespace-nowrap font-Open font-normal leading-5 text-sm">
            ₹ {yaariCashBalance}
          </div>
        );
      },
    }),

    //   header: () => {
    //     return (
    //       <div className="flex justify-between items-center">
    //         <h1 className="font-Open font-semibold leading-5 text-sm">
    //           Cashback
    //         </h1>
    //         {/* <img src={sortIconTable} alt="" onClick={handleSortClick} /> */}
    //       </div>
    //     );
    //   },
    //   cell: (info: any) => {
    //     let yaariCash = parseFloat(info.getValue()).toFixed(2);

    //     return (
    //       <div className="flex whitespace-nowrap font-Open font-normal leading-5 text-sm">
    //         ₹ {yaariCash}
    //       </div>
    //     );
    //   },
    // }),

    // columnsHelper.accessor("type", {
    //   header: () => {
    //     return (
    //       <div className="flex justify-between items-center">
    //         <h1 className="font-Open font-semibold leading-5 text-sm">Type</h1>

    //         {/* <img src={sortIconTable} alt="" /> */}
    //       </div>
    //     );
    //   },
    //   cell: (info: any) => {
    //     return (
    //       <div className="flex">
    //         <span className="font-Open font-normal leading-5 text-sm">
    //           {capitalizeFirstLetter(info?.row?.original?.type) || "-"}
    //         </span>
    //       </div>
    //     );
    //   },
    // }),

    columnsHelper.accessor("remark", {
      header: () => {
        return (
          <div className="flex justify-between items-center">
            <h1 className="font-Open font-semibold leading-5 text-sm">
              Remark
            </h1>

            {/* <img src={sortIconTable} alt="" /> */}
          </div>
        );
      },
      cell: (info: any) => {
        return (
          <div className="flex">
            <span className="font-Open font-normal leading-5 text-sm">
              {capitalizeFirstLetter(info?.row?.original?.remark) || "-"}
            </span>
          </div>
        );
      },
    }),
    columnsHelper.accessor("status", {
      header: () => {
        return (
          <div className="flex min-w-[118px] items-center justify-between gap-2">
            <div>
              <h1 className="font-Open font-semibold leading-5 text-sm">
                Status
              </h1>
            </div>
            {onStatusFilterClick && (
              <button
                type="button"
                className={`flex h-7 w-7 items-center justify-center rounded border ${
                  statusFilterActive
                    ? "border-[#004EFF] bg-[#F0F5FF]"
                    : "border-transparent hover:border-[#E8E8E8] hover:bg-[#FAFAFA]"
                }`}
                onClick={onStatusFilterClick}
                title="Filter by status"
                aria-label="Filter by status"
              >
                <img src={filterIconTable} alt="" className="h-4 w-4" />
              </button>
            )}
          </div>
        );
      },
      cell: (info: any) => {
        return renderStatusComponent(info.getValue());
      },
    }),

    columnsHelper.accessor("actions", {
      header: () => {
        return (
          <div className="flex justify-between">
            <h1 className="text-sm font-semibold leading-5 ">Actions</h1>
          </div>
        );
      },
      cell: (info: any) => {
        return (
          <div className="flex space-x-2 items-center cursor-pointer">
            <CopyTooltip stringToBeCopied={info.row?.original} />
          </div>
        );
      },
    }),
  ];
};

export const CashbackHistory: React.FunctionComponent<ICashbackProps> = ({
  data,
}) => {
  const [onOpen, setOnOpen] = useState(false);

  const header = () => {
    return (
      <div
        className={`border-[1px] border-[#E8E8E8] rounded-lg overflow-hidden ${
          onOpen ? "grid grid-rows-1" : "grid h-[44px]"
        }`}
      >
        <div
          className={`flex justify-between items-center h-[44px] ${
            onOpen ? "bg-[#E8E8E8]" : "bg-white"
          }`}
        >
          <div>
            <span className="text-base font-semibold text-[#1C1C1C] ml-4">
              {data?.title}
            </span>
          </div>
          <div className="flex items-center mr-4">
            <div>
              <CustomButton
                text={data?.rupee}
                onClick={() => {}}
                className="p-2 !bg-[#004EFF] text-white text-[12p] h-[28px]"
                showIcon={true}
                icon={RupeeIcon}
                iconClass={"w-[7px] mr-1"}
              />
            </div>
            <div>
              <img
                src={onOpen ? UpArrowIcon : DownArrowIcon}
                alt=""
                className="ml-4"
                onClick={() => setOnOpen(!onOpen)}
              />
            </div>
          </div>
        </div>

        <Collapsible open={onOpen} trigger="">
          <div className="grid grid-cols-2 ml-4 mt-4">
            <div className="flex flex-col">
              <span className="text-[10px] text-[#777777] font-normal">
                Date
              </span>
              <div className="flex">
                <img src={RupeeIcon} alt="Rupee" className="mr-1 h-[10px]" />
                <span className="text-xs text-[#1C1C1C] font-semibold	">
                  {data?.date}
                </span>
              </div>
            </div>

            <div className="flex flex-col border-[#E8E8E8] border-l-[1px]">
              <span className="ml-3 text-[10px] text-[#777777] font-normal">
                Time
              </span>
              <span className="ml-3 flex text-xs text-[#1C1C1C] font-semibold">
                <img src={RupeeIcon} alt="Rupee" className="mr-1 h-[10px]" />
                <span>{data?.time}</span>
              </span>
            </div>
          </div>

          <div className="flex flex-col ml-4 mt-2 mb-4">
            <span className="text-[10px] text-[#777777] font-normal">
              Description
            </span>
            <span className="text-xs text-[#1C1C1C] font-semibold">
              {data?.description}
            </span>
          </div>
        </Collapsible>
      </div>
    );
  };

  return <>{header()}</>;
};
